import axios from 'axios'
import { apiDomain } from '../../config'

let axiosConfigRequest = {
	headers: {
		'Content-Type': 'application/json',
		'token': localStorage.getItem('access_token')
	}
}

export default {
	getDashboard(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getTargetIter(filter_by, id) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/target/'+id+'/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getTargetList(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/target/list/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAlerts(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/alerts/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAvgDailyDistance(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/avg_daily/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getWaitTimeChart(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/wait_time/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getTargetChart(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/target/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAvgMinuteLoadChart(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/avg_minute/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getFluidByUnloadChart(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/fluid_by_location/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getFluidByLoadChart(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/fluid_by_load/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getChartConfigs() {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/user/config/', {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data.configs.dashboard_charts)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	putChartConfigs(config) {
		console.log('dasdasd',config)
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/user/config/', {"dashboard_charts":config}, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	Config_Formula(config) {
		return new Promise((resolve, reject) => {
			axios.put(apiDomain + '/user/config_formula/', {"formula":config}, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data
						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAlerts_tc() {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/dash/alerts/', {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data
						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	dashboard_tc() {
		return new Promise((resolve, reject) => {
			axios.get(apiDomain + '/dash_tc/', {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data
						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_volume_by_date(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/volume_by_date/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	get_volume_user(filter_by) {
		return new Promise((resolve, reject) => {
			axios.post(apiDomain + '/dashboard/volume_user/', filter_by, {
				headers: {
					'Content-Type': 'application/json',
					'token': localStorage.getItem('access_token')
				}
			})
				.then((response) => {
					var data = ''
					if (response.data.status === 'success') {
						data = response.data
						resolve(data)
					} else {
						data = response.data

						resolve(data)
					}
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
}



// WEBPACK FOOTER //
// ./src/views/dashboard/dashboard_service.js